<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { MarkComponentProps } from '@portabletext/svelte';
  import FontDecorator from '../Decorators/FontDecorator.svelte';

  interface Props {
    portableText: MarkComponentProps<{
      markKey: string;
    }>;
    children?: Snippet;
  }

  let { portableText, children }: Props = $props();
  let font: 'pp-neue-machina' | 'pilat-wide' = $derived(
    portableText.markKey === 'fontsPPNeueMachina' ? 'pp-neue-machina' : 'pilat-wide'
  );
</script>

<FontDecorator {font}>
  {@render children?.()}
</FontDecorator>
